<template>
  <div class="text-center">
    <p class="desc text-center">
      <span class="empty-title" v-html="title" />
    </p>
    <p class="desc text-center">
      <span class="empty-content" v-html="body" />
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    body: String,
  },
}
</script>

<style scoped>
.empty-title {
  color: white;
  font-style: normal;
  font-weight: 800;
  font-size: 36px;
  line-height: 40px;
}
.empty-content {
  color: #869399;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px;
  color: #96a7af;
}
</style>
